import { Controller } from "@hotwired/stimulus"

// Carries flagged items' notes that were typed but never saved on their own
// ("Save note") into the Complete form as it is sent, so pressing Complete
// does not throw them away. Inspection#complete saves them before it
// completes -- and keeps them if the completion is refused. "Report an
// issue" on a flagged item leaves the page too, so it carries them the same
// way (#carryOnReport; InspectionItemsController saves them).
//
// Without JavaScript each note still has its own Save note button; this only
// closes the gap of a note typed and then forgotten.
//
// Markup contract:
//   <div data-controller="unsaved-notes">
//     <input data-unsaved-notes-target="note" data-item-id="12" data-saved="Low">   (one per flagged item)
//     <form data-action="submit->unsaved-notes#carry">…</form>                  (Complete)
//     <form data-action="submit->unsaved-notes#carryOnReport">…</form>          (a flagged item's note)
export default class extends Controller {
  static targets = ["note"]

  // Runs on the form before Turbo reads it (Turbo builds its request in the
  // submit event's bubbling phase at the document), so the fields added here
  // are sent.
  carry(event) {
    const form = event.target
    form.querySelectorAll("input[data-carried-note]").forEach((input) => input.remove())

    this.noteTargets.forEach((note) => {
      if (note.value.trim() === note.dataset.saved) return

      const carried = document.createElement("input")
      carried.type = "hidden"
      carried.name = `inspection[item_notes][${note.dataset.itemId}]`
      carried.value = note.value
      carried.dataset.carriedNote = ""
      form.appendChild(carried)
    })
  }

  // Only for the submit that leaves the page: Save note answers with a
  // Turbo Stream and every other row stays, typed notes and all.
  carryOnReport(event) {
    if (event.submitter?.name === "report") this.carry(event)
  }
}
